(() => {
  if (window.ccModelGalleries) { window.ccModelGalleries.init(); return; }
  const sources = new Map();
  const galleries = new Set();
  async function source(url) {
    if (!sources.has(url)) sources.set(url, fetch(url).then(r => { if (!r.ok) throw new Error('Gallery unavailable'); return r.json(); }));
    return sources.get(url);
  }
  function show(state, color, requestedView) {
    const photos = state.data.colors[color];
    if (!photos) return;
    const views = ['front', 'back'].filter(view => photos[view]);
    if (!views.length) return;
    const view = views.includes(requestedView) ? requestedView : views[0];
    state.color = color; state.view = view;
    const image = state.root.querySelector('.cc-model-gallery__image');
    image.src = photos[view];
    image.alt = state.data.title + (color === 'Default' ? '' : ' in ' + color) + ' — ' + view + ' view';
    const controls = state.root.querySelector('.cc-model-gallery__views');
    controls.replaceChildren();
    controls.hidden = views.length < 2;
    for (const name of views) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = name === 'front' ? 'Front' : 'Back';
      button.setAttribute('aria-pressed', String(name === view));
      button.addEventListener('click', () => show(state, state.color, name));
      controls.append(button);
    }
    state.root.querySelector('.cc-model-gallery__caption').textContent = (color === 'Default' ? '' : color + ' · ') + (view === 'front' ? 'Front view' : 'Back view');
  }
  function variantId(root) {
    const container = root.closest('[data-section-type="product"], .product-section, .shopify-section');
    const field = container && container.querySelector('form[action*="/cart/add"] [name="id"]');
    return String(field && field.value || root.dataset.variantId || '');
  }
  async function init() {
    for (const root of document.querySelectorAll('[data-cc-model-gallery]')) {
      if (root.dataset.ccReady) continue;
      root.dataset.ccReady = 'loading';
      try {
        const all = await source(root.dataset.gallerySource);
        const data = all[root.dataset.productId];
        if (!data) { delete root.dataset.ccReady; continue; }
        const state = {root, data, color:null, view:'front'};
        galleries.add(state);
        show(state, data.variantColors[variantId(root)] || data.defaultColor, 'front');
        root.dataset.ccReady = 'true';
      } catch (_) { delete root.dataset.ccReady; }
    }
  }
  document.addEventListener('variant:change', event => {
    const id = String(event.detail && event.detail.variant && event.detail.variant.id || '');
    if (!id) return;
    for (const state of galleries) {
      if (!state.root.isConnected) { galleries.delete(state); continue; }
      if (Object.prototype.hasOwnProperty.call(state.data.variantColors, id)) show(state, state.data.variantColors[id], 'front');
    }
  });
  document.addEventListener('shopify:section:load', init);
  let timer;
  const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(init, 80); });
  observer.observe(document.documentElement, {childList:true, subtree:true});
  window.ccModelGalleries = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

